﻿import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as Ids from './Models/Ids';
import VeilederRenterDto from './Models/VeilederRenterDto';

const root = document.getElementById(Ids.AppContainerId)!;
if (!root) {
    throw new Error('Fant ikke div med id: ' + Ids.AppContainerId);
}

async function main() {
    if (!root.dataset.side) {
        throw new Error('Fant ikke side i div med id: ' + Ids.AppContainerId);
    }

    const side = JSON.parse(root.dataset.side) as VeilederRenterDto;

    ReactDOM.createRoot(root).render(
        <StrictMode>
            <App side={side} />
        </StrictMode>
    );
}

main();
